import * as React from "react"

type Props = {
  list: {
    url: string
    name: string
  }[]
  classes?: string
}

const Breadcrumb: React.FC<Props> = ({ list, classes = "" }) => (
  <ol
    className={"breadcrumb flex overflow-x-scroll " + classes}
    vocab="https://schema.org/"
    typeof="BreadcrumbList"
  >
    {list.map((item, i) => {
      return (
        <li
          key={`breadcrumb-item-${i}`}
          className={
            "breadcrumb-item font-hiragino text-sm text-gray-600 whitespace-nowrap"
          }
          property="itemListElement"
          typeof="ListItem"
        >
          <a
            className="no-underline"
            property="item"
            typeof="WebPage"
            href={item.url}
          >
            <span property="name">{item.name}</span>
          </a>
          <meta property="position" content={`${i + 1}`} />
        </li>
      )
    })}
  </ol>
)

export default Breadcrumb
